/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Venue_Multiple_LiveInputs */

const th_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มีหลายเกมกำลังแข่งที่สถานที่นี้ โปรดตรวจสอบการจัดสนาม`)
};

const en_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiple games are live at this venue. Check the assignment.`)
};

const ja_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この会場で複数の試合が進行中です。割り当てをご確認ください。`)
};

const zh_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此场馆有多场比赛正在直播。请检查安排。`)
};

const es_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hay varios partidos en directo en este pabellón. Revisa la asignación.`)
};

const pt_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há vários jogos ao vivo neste ginásio. Confira a escalação.`)
};

const id_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beberapa pertandingan berlangsung di tempat ini. Periksa penugasannya.`)
};

const fr_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusieurs matchs sont en direct dans cette salle. Vérifiez l’attribution.`)
};

const tl_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maraming laro ang live sa venue na ito. Suriin ang mga naitalaga.`)
};

const vi_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhiều trận đang đấu tại địa điểm này. Kiểm tra lại phân công.`)
};

const ko_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 경기장에서 여러 경기가 동시에 진행 중입니다. 배정을 확인하세요.`)
};

const de_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In dieser Halle laufen mehrere Spiele live. Prüfe die Zuordnung.`)
};

const ru_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На этой площадке идёт несколько матчей. Проверьте назначения.`)
};

const tr_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu salonda birden çok maç canlı. Atamaları kontrol edin.`)
};

const it_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In questo impianto ci sono più partite in diretta. Controlla le assegnazioni.`)
};

const pl_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W tej hali trwa kilka meczów jednocześnie. Sprawdź przypisania.`)
};

const uk_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На цьому майданчику одночасно триває кілька матчів. Перевірте призначення.`)
};

const hi_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस स्थल पर एक से अधिक मैच लाइव हैं। नियुक्तियाँ जाँचें।`)
};

const ar_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تُلعب عدة مباريات مباشرة في هذه الصالة. راجع التعيينات.`)
};

const ms_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beberapa perlawanan berlangsung di tempat ini. Semak tugasan.`)
};

const bn_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই মাঠে একাধিক খেলা সরাসরি চলছে। নিয়োগ দেখে নিন।`)
};

const zh_tw2_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個場館有多場比賽同時直播。請檢查安排。`)
};

const zh_hk2_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個場館有多場比賽同時直播。請檢查安排。`)
};

const ur_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس مقام پر ایک سے زیادہ میچ براہ راست ہیں۔ تقرری دیکھ لیں۔`)
};

const fa_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`چند بازی هم‌زمان در این سالن زنده است. تعیین‌ها را بررسی کنید.`)
};

const sw_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuna michezo kadhaa moja kwa moja kwenye ukumbi huu. Angalia upangaji.`)
};

const nl_venue_multiple_live = /** @type {(inputs: Venue_Multiple_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In deze zaal zijn meerdere wedstrijden live. Controleer de indeling.`)
};

/**
* | output |
* | --- |
* | "Multiple games are live at this venue. Check the assignment." |
*
* @param {Venue_Multiple_LiveInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const venue_multiple_live = /** @type {((inputs?: Venue_Multiple_LiveInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Venue_Multiple_LiveInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_venue_multiple_live(inputs)
	if (locale === "ja") return ja_venue_multiple_live(inputs)
	if (locale === "zh") return zh_venue_multiple_live(inputs)
	if (locale === "es") return es_venue_multiple_live(inputs)
	if (locale === "pt") return pt_venue_multiple_live(inputs)
	if (locale === "id") return id_venue_multiple_live(inputs)
	if (locale === "fr") return fr_venue_multiple_live(inputs)
	if (locale === "tl") return tl_venue_multiple_live(inputs)
	if (locale === "vi") return vi_venue_multiple_live(inputs)
	if (locale === "ko") return ko_venue_multiple_live(inputs)
	if (locale === "de") return de_venue_multiple_live(inputs)
	if (locale === "ru") return ru_venue_multiple_live(inputs)
	if (locale === "tr") return tr_venue_multiple_live(inputs)
	if (locale === "it") return it_venue_multiple_live(inputs)
	if (locale === "pl") return pl_venue_multiple_live(inputs)
	if (locale === "uk") return uk_venue_multiple_live(inputs)
	if (locale === "hi") return hi_venue_multiple_live(inputs)
	if (locale === "ar") return ar_venue_multiple_live(inputs)
	if (locale === "ms") return ms_venue_multiple_live(inputs)
	if (locale === "bn") return bn_venue_multiple_live(inputs)
	if (locale === "zh-TW") return zh_tw2_venue_multiple_live(inputs)
	if (locale === "zh-HK") return zh_hk2_venue_multiple_live(inputs)
	if (locale === "ur") return ur_venue_multiple_live(inputs)
	if (locale === "fa") return fa_venue_multiple_live(inputs)
	if (locale === "sw") return sw_venue_multiple_live(inputs)
	if (locale === "nl") return nl_venue_multiple_live(inputs)
	return en_venue_multiple_live(inputs)
});